import { render, staticRenderFns } from "./RemittanceOperationReport.vue?vue&type=template&id=5bd8381f&scoped=true"
import script from "./RemittanceOperationReport.vue?vue&type=script&lang=js"
export * from "./RemittanceOperationReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd8381f",
  null
  
)

export default component.exports